"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_lottie_1 = __importDefault(require("react-lottie"));
require("./claimingProcessBlock.scss");
const claimingProcessLoader_json_1 = __importDefault(require("../../../assets/lotties/claimingProcessLoader.json"));
const claimingProcessBlockTranslations_json_1 = __importDefault(require("./claimingProcessBlockTranslations/claimingProcessBlockTranslations.json"));
function ClaimingProcessBlock(props) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: claimingProcessLoader_json_1.default,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    props.addTranslation(claimingProcessBlockTranslations_json_1.default);
    return (react_1.default.createElement("div", { id: "claiming-process-block", className: "flex-column jc-c ai-c" },
        react_1.default.createElement(react_lottie_1.default, { options: defaultOptions, height: 38, width: 38 }),
        react_1.default.createElement("span", { className: "claiming-from-text" }, props
            .translate("checkingCredentialsFrom")
            .toString()
            .replace("${orgName}", props.claimOrganizationTitle)),
        react_1.default.createElement("span", { className: "may-take-text" }, props.translate("thisMayTakeFewMinutes").toString())));
}
exports.default = ClaimingProcessBlock;
